exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3cfL1{text-align:center;margin:40px}._2DQCa{text-align:left;margin-bottom:24px}._2DQCa ._2cyDl{width:300px;cursor:pointer}._1o-HY ._1az2Q{width:220px}._1o-HY ._2dGVm{font-size:18px;margin:40px 0 20px}body.reader-night-mode ._1o-HY ._2dGVm{color:#b3b3b3}._1o-HY ._3BFwp{font-size:14px;margin-bottom:30px;color:#333}body.reader-night-mode ._1o-HY ._3BFwp{color:#b3b3b3}._3h9Y3{height:48px;border-radius:24px;font-size:15px;padding:6px 20px}", ""]);

// exports
exports.locals = {
	"wrapper": "_3cfL1",
	"header": "_2DQCa",
	"logo": "_2cyDl",
	"content": "_1o-HY",
	"img-404": "_1az2Q",
	"title": "_2dGVm",
	"desc": "_3BFwp",
	"btn": "_3h9Y3"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[hash:base64:5]","importLoaders":2}!./node_modules/postcss-loader/lib!./node_modules/sass-loader/lib/loader.js!./src/pages/NotFoundPage/NotFoundPage.scss
// module id = 1qel
// module chunks = 2